import React from 'react'
import styled from 'styled-components'
import { SeparatorLine } from '../../SeparatorLine'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'
import { DEVICES, SIZES } from '../../../constants'
import { UTM_CONTENT } from './constants'
import { sendWidgetClick } from '../../utils/ga4Events'
import { getLinkTarget } from '../../utils/getLinkTarget'

const Wrapper = styled.div`
  position: relative;

  @media (max-width: ${SIZES.BREAKPOINT_XS}px) {
    margin-top: 32px;
  }
`

const Image = styled.img`
  height: 179px;
  margin-bottom: 40px;
`

const Link = styled.a`
  position: absolute;
  width: 200px;
  height: 50px;
  opacity: 0;
`

const TitleLink = styled(Link)`
  top: 15px;
  left: 60px;
`

const ButtonLink = styled(Link)`
  bottom: 60px;
  right: 25px;
`

export const PujduAdvert = (props) => {
  const {
    activeDynamicLayout,
    utmMedium,
    widget: {
      meta: {
        button: {
          location
        }
      }
    }
  } = props

  const utmTitleLink = utmLinkGenerator.createLink(location, { utmMedium, utmContent: UTM_CONTENT.title })
  const utmButtonLink = utmLinkGenerator.createLink(location, { utmMedium, utmContent: UTM_CONTENT.button })

  const handleClick = (location) => {
    sendWidgetClick({
      name: 'pujdu-b',
      click: {
        type: 'link',
        position: 8,
        location
      }
    })
  }

  return (
    <Wrapper>
      <Image src={`${STATICS_PATH}images/pujdu/pujdu-advert.svg`}/>
      <TitleLink onClick={handleClick} href={utmTitleLink} target={getLinkTarget(activeDynamicLayout)}/>
      <ButtonLink onClick={handleClick} href={utmButtonLink} target={getLinkTarget(activeDynamicLayout)}/>
      { activeDynamicLayout === DEVICES.DESKTOP && <SeparatorLine/> }
    </Wrapper>
  )
}
